import { render, staticRenderFns } from "./ColumnCard.vue?vue&type=template&id=2d9de028&scoped=true"
import script from "./ColumnCard.vue?vue&type=script&lang=ts"
export * from "./ColumnCard.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ColumnCard.vue?vue&type=style&index=0&id=2d9de028&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2d9de028",
  "6e99bc5d"
  
)

export default component.exports